/**
 * Timeline für das Abspielen der Animationen innerhalb eines Seitenablaufs
 * @class service_v3sTimelineService
 * @memberOf v3sWbtPlayerApp:animation
 */
angular.module('v3sWbtPlayerApp').factory('v3sTimelineService', ["$rootScope", "v3sAnimationService", "$timeout", function ($rootScope, v3sAnimationService, $timeout) {

    var timeline, asyncTweens, lastTime, playing, progress, progressBar, tweenMoveTo, started, pauseTimer, jumpBlock, userInteractionAllowed;
    var tolerance = 0.01;

    /**
      * Initialisiert die Timeline
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      */
    function init() {
        timeline = new TimelineMax({ onUpdate: notifyProgress, onComplete: notifyCompleted, paused: true });
        asyncTweens = [];
        lastTime = 0;
        progress = 0;
        playing = false;
        started = false;
        userInteractionAllowed = true;

        /**
        * Erweitert Timeline, damit Tweens Progressbar aktualisieren können
        */
        timeline.data = {
            updateProgressBar: updateProgressBar,
            allowUserInteraction: allowUserInteraction,
            togglePause: togglePause,
            addPause: addPause,
            jumpTo: jumpTo
        };
    }

    /**
     * Fügt eine Reihe von Animation hinzu, die demselben Zeitpunkt zugeordnet werden.
     * @param {object} period - Periode mit Aktionen
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function addPeriod(period) {
        lastTime += period.intervall;
        var label = "Time" + lastTime;

        timeline.addLabel(label, lastTime);
        angular.forEach(period.actions, function (action) {
            var tween = v3sAnimationService.createTween(action);
            timeline.add(tween, label);

            if (!!tween.data && !!tween.data.onInit) {
                tween.data.onInit(timeline, tween, label);
            }
        });
    }

    /**
     * Fügt eine asynchrone Animation (Benutzer-Interaktion/Animation mit Bedingung) hinzu
     * @param {object} action - Asynchrone Aktion
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function addAsyncAction(action) {
        if (!!timeline) {

            var tween = v3sAnimationService.createTween(action);

            //Pause, falls Timeline noch nicht gestartet wurde (damit Medien auf dem iPad laufen)
            if (!started) {
                tween.paused(true);
            }

            asyncTweens.push({ tween: tween, time: timeline.time() }); // timeline.progress() wird bei Audio-/Videostart ungünstig verändert
            if (!!tween.data && !!tween.data.onInit) {
                tween.data.onInit(timeline, tween);
            }
        }
    }

    /**
     * Spielt asynchrone Animationen (Benutzer-Interaktionen/Animationen mit Bedingungen) ab, somit werden auch Medien auf dem iPad abgespielt
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function playAsyncTweens() {
        for (var i = 0; i < asyncTweens.length; i++) {
            if (asyncTweens[i].tween.paused()) {
                asyncTweens[i].tween.play();
            }
        }
    }

    /**
     * Räumt asynchrone Animationen (Benutzer-Interaktionen/Animationen mit Bedingungen)  auf
     * @param {number} time - Timeline-Zeit in Sekunden, nach dem alle Benutzer-Animationen gelöscht werden sollen
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function clearAsyncTweens(time) {
        for (var i = asyncTweens.length - 1; i >= 0; i--) {
            if (asyncTweens[i].time > time) {
                var tween = asyncTweens[i].tween;
                tween.progress(0);
                tween.kill();
                asyncTweens.splice(i, 1);
            } else {
                return;
            }
        }
    }

    /**
     * Startet Pause-Funktion in allen horchenden Tweens in der Timeline (z. B. für Mediensteuerung)
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function pauseTweens() {
        var children = timeline.getChildren(false, true, false, 0);
        for (var i = 0; i < children.length; i++) {
            var tween = children[i];
            if (!!tween.data && !!tween.data.onPause) {
                tween.data.onPause();
            }
        }
    }

    /**
     * Startet Play-Funktion in allen horchenden Tweens in der Timeline (z. B. für Mediensteuerung)
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function playTweens() {
        var children = timeline.getChildren(false, true, false, 0);
        for (var i = 0; i < children.length; i++) {
            var tween = children[i];
            if (!!tween.data && !!tween.data.onPlay) {
                tween.data.onPlay();
            }
        }
    }

    /**
      * Spielt die Timeline ab
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      */
    function play() {
        started = true;
        playAsyncTweens();

        if (timeline.progress() != 1) {
            timeline.play();
        }
    }

    /**
    * Schaltet die Pause ein
    * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
    */
    function pause(params) {
        if (!timeline.paused()) {
            togglePause(true, params);
        }
    }

    /**
    * Schaltet die Pause ein/aus
    * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
    */
    function togglePause(pause, params) {
        if (pause != true && pause != false) {
            pause = !timeline.paused();
        }

        timeline.paused(pause);

        if (pause) {
            notifyPaused(params);
        } else {
            $timeout.cancel(pauseTimer);
        }

    }

    /**
    * Definiert eine Pause
    * @param {string} label - Sprungmarke
    * @param {number} delay - Abstand zur Sprungmarke
    * @param {number} maxTime - max. Zeit der Pause
    * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
    */
    function addPause(label, delay, maxTime) {

        var pauseLabel = "pause" + label + delay;
        timeline.addLabel(pauseLabel, label + "+=" + delay);

        timeline.addPause(pauseLabel, function () {
            $timeout(notifyPaused);
            if (maxTime > 0) {
                pauseTimer = $timeout(function () {
                    togglePause(false);
                }, maxTime * 1000);
            }
        });
    }

    /*
    * Springt zur bestimmter Zeit in der Timeline
    * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
    * @param {number} time - Sprung zur Zeit
    */
    function jumpTo(time, block) {
        if (!jumpBlock) {

            if (!!tweenMoveTo) {
                tweenMoveTo.progress(1);
            }

            jumpBlock = !!block;

            pause({ silent: true });
            tweenMoveTo = timeline.tweenTo(time, {
                onComplete: function () {
                    tweenMoveTo = null;
                    jumpBlock = false;
                    play();
                }
            }).duration(0.5);
        }
    }

    /**
      * Springt zur nächsten Periode in der Timeline, mindestens +=5 Sekunden
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      */
    function nextPeriod() {

        var time = timeline.time();
        var nextTimeJump;

        var labels = timeline.getLabelsArray();
        for (var i = 0; i < labels.length; i++) {
            nextTimeJump = labels[i].time - time;
            if ((nextTimeJump > 0 && labels[i].name.indexOf("pause") == 0) || (nextTimeJump > 5)) {
                break;
            }
        }

        if (nextTimeJump < 0) {
            nextTimeJump = 5;
        }
        if (nextTimeJump > 30) {
            nextTimeJump = 30;
        }

        jumpTo(time + nextTimeJump - tolerance);
    }

    /**
      * Springt zur vorherigen Periode in der Timeline, mindestens -=5 Sekunden
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      */
    function prevPeriod() {

        var time = timeline.time();
        var prevLabel = timeline.getLabelBefore(time);
        var prevTime;
        if (!!prevLabel) {
            prevTime = timeline.getLabelTime(prevLabel) - 1;
            if (time - prevTime < 5) {
                prevTime = time - 5;
            }
        }

        if (!prevTime || prevTime < 0) {
            prevTime = 0;
        };

        if (time - prevTime > 30) {
            prevTime = time - 30;
        }

        jumpTo(prevTime);
    }

    /**
      * Ändert Fortschritt der Timeline
      * @param {number} newProgress - Fortschritt in Prozent, von 0 bis 1 (z. B. 0.5 == 50%)
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      */
    function setProgress(newProgress) {
        var currentTime = timeline.time();
        var newTime = timeline.totalDuration() * newProgress;
        var oldProgress = 0;

        if (currentTime < newTime) {
            var pauseLabel;
            var labels = timeline.getLabelsArray();
            for (var i = 0; i < labels.length; i++) {
                if (labels[i].time >= currentTime && labels[i].time <= newTime && labels[i].name.indexOf("pause") == 0) {
                    if (labels[i].time == currentTime) {
                        newTime = -1;
                    } else {
                        newTime = labels[i].time - tolerance;
                    }

                    break;
                }
            }
        }

        if (newTime >= 0) {
            jumpTo(newTime);
        } else {
            oldProgress = timeline.progress();
        }
        return oldProgress;
    }

    /**
      * Hört auf den Abspiel-Event der Timeline
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      * @listens v3sTimelineServicePlaying
      */
    function subscribePlaying(scope, callback) {
        var handler = $rootScope.$on('v3sTimelineServicePlaying', callback);
        scope.$on('$destroy', handler);
    }

    /**
      * Erzeugt einen Event beim Abspielen der Timeline
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      * @emits v3sTimelineServicePlaying
      */
    function notifyPlaying() {
        playing = true;
        playTweens();
        $rootScope.$emit('v3sTimelineServicePlaying');
    }

    /**
    * Hört auf den Pause-Event der Timeline
    * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
    * @listens v3sTimelineServicePaused
    */
    function subscribePaused(scope, callback) {
        var handler = $rootScope.$on('v3sTimelineServicePaused', callback);
        scope.$on('$destroy', handler);
        }

    /**
      * Erzeugt einen Event beim Abspielen der Timeline
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      * @emits v3sTimelineServicePaused
      */
    function notifyPaused(params) {
        playing = false;
        pauseTweens();
        if (!params || !params.silent) {
            $rootScope.$emit('v3sTimelineServicePaused');
        }
    }


    /**
     * Erlaubt Nutzer Timeline-Ablauf zu verändern (Pause, Sprung, ...)
     * @param {bool} value - aktiviert/deaktiviert die Funktion
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function allowUserInteraction(value) {
        userInteractionAllowed = value;

        if (!!progressBar) {
            progressBar.disable(!value);
        }
    }

    /**
     * Gibt zurück, ob Nutzer Timeline-Ablauf verändern darf (Pause, Sprung, ...)
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function isUserInteractionAllowed() {
        return userInteractionAllowed;
    }

    /**
     * Legt die Fortschritt-Anzeige fest
     * @param {object} element - Fortschritt-Anzeige
     * @param {object} paramFrom - Startwert der Fortschritt-Anzeige
     * @param {object} paramTo - Endwert der Fortschritt-Anzeige
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function setProgressBar(_progressBar) {
        progressBar = _progressBar;
        progressBar.paramTo.ease = Linear.easeNone;
        updateProgressBar();
    }

    /**
     * Aktualisiert die Animation der Fortschritt-Anzeige, nachdem die Timeline geändert wurde
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function updateProgressBar() {
        if (!!timeline && !!progressBar) {
            var duration = timeline.duration();
            if (!duration) {
                duration = 0;
            }

            var progressBarTween = TweenMax.fromTo(progressBar.element, duration, progressBar.paramFrom, progressBar.paramTo);
            timeline.add(progressBarTween, 0);
        }
    }

    /**
      * Hört auf den Progress-Event der Timeline (Änderung des Fortschritts)
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      * @listens v3sTimelineServiceCompleted
      */
    function subscribeProgress(scope, callback) {
        var handler = $rootScope.$on('v3sTimelineServiceProgress', function () {
            callback(progress);
        });
        scope.$on('$destroy', handler);
    }

    /**
      * Erzeugt einen Event bei Änderung des Fortschritts der Timeline; Empfindlichkeit: 1% des Fortschritts
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      * @emits v3sTimelineServiceCompleted
      */
    function notifyProgress() {
        var newProgress = timeline.progress();

        if (!isNaN(newProgress)) {

            if (progress != 1 && !playing && !tweenMoveTo) {
                notifyPlaying();
                progress = 0;
            }

            newProgress = Math.round(newProgress * 100) / 100;
            if (newProgress != progress) {
                if (newProgress < progress) {
                    clearAsyncTweens(timeline.time());
                }

                progress = newProgress;

                /*if (progressBar) {
                    progressBar.element.noUiSlider.set(newProgress);
                }*/

                $rootScope.$emit('v3sTimelineServiceProgress');
            }
        } else {
            progress = 1;
            $rootScope.$emit('v3sTimelineServiceProgress');
        }
    }

    /**
      * Hört auf den Beenden-Event der Timeline
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      * @listens v3sTimelineServiceCompleted
      */
    function subscribeCompleted(scope, callback) {
        var handler = $rootScope.$on('v3sTimelineServiceCompleted', callback);
        scope.$on('$destroy', handler);
    }

    /**
      * Erzeugt einen Event beim Beenden der Timeline
      * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
      * @emits v3sTimelineServiceCompleted
      */
    function notifyCompleted() {
        playing = false;
        $rootScope.$emit('v3sTimelineServiceCompleted');
    }

    /**
     * Stoppt alle Animationen in der Timeline und räumt die Timeline auf
     * @memberOf v3sWbtPlayerApp:animation.service_v3sTimelineService
     */
    function destroy() {
        if (!!tweenMoveTo) {
            tweenMoveTo.kill();
        }

        timeline.kill();

        timeline = null;
        tweenMoveTo = null;
        asyncTweens = null;
        progressBar = null;
    }

    return {
        init: init,
        addPeriod: addPeriod,
        addAsyncAction: addAsyncAction,
        play: play,
        togglePause: togglePause,
        nextPeriod: nextPeriod,
        prevPeriod: prevPeriod,
        isUserInteractionAllowed: isUserInteractionAllowed,
        setProgressBar: setProgressBar,
        setProgress: setProgress,
        subscribePlaying: subscribePlaying,
        subscribePaused: subscribePaused,
        subscribeProgress: subscribeProgress,
        subscribeCompleted: subscribeCompleted,
        destroy: destroy
    };
}]);
